<template>
  <div class="mb-2 root background_screen">
    
    <v-form
      ref="filter"
      class="mx-2"
    >
      <v-toolbar
        flat
        class="my-3 background_screen"
      >
        <v-toolbar-title>Acionamento de Conjuntos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="d-flex align-center justify-space-around mx-2">
          
          <v-autocomplete
            v-model="controller.selectedPlace"
            :items="controller.placePagination.items"
            item-text="name"
            item-value="id"
            dense
            filled
            class="pt-6 pl-2"
            label="Selecione o Levante"
            style="max-width: 14rem"
            return-object
            @change="controller.changePlace($event)"
            single-line
          ></v-autocomplete>
          <div class="ml-2">
            <v-btn
              v-if="selectedItems.length !== 0"
              height="38"
              color="primary"
              class="mt-0"
              @click="toggleStatusForSelectedItems"
            >
              <v-icon left> mdi-swap-horizontal </v-icon>
              Alterar Estado
            </v-btn>
          </div>
        </v-toolbar-items>
      </v-toolbar>
    </v-form>
    
    <div v-if="!controller.selectedPlace.name || controller.pumpMotoPagination.items.length === 0" class="warning-message">
      <v-alert class="text-h6">
        {{ !controller.selectedPlace.name ? 'Por favor, selecione um levante para visualizar os conjuntos.' : 'Não foram encontrados conjuntos para o levante selecionado.' }}
      </v-alert>
    </div>

    <div
      v-if="controller.selectedPlace.name"
      :class="{
        'd-flex mt-3 mb-n4 pa-8 justify-space-between': true,
        'flex-column-reverse mt-0': $vuetify.breakpoint.smAndDown,
        'background_screen': $vuetify.theme.isDark,
        'white-bg': !$vuetify.theme.isDark
      }"
    >
      <div :class="{'d-flex flex-column': true, 'mt-8': $vuetify.breakpoint.smAndDown}">
        <div class="d-flex justify-start">
          <div>
            <span class="text-subtitle-1">Acionamentos</span>
          </div>
          <div>
            <v-icon class="mr-2">mdi-chevron-right</v-icon>
            <span class="text-subtitle-1">{{ controller.selectedPlace.name }}</span>
          </div>
        </div>

        <last-place-event
          :last-event="controller.lastPlaceEvent"
          :place="controller.selectedPlace"
        />

        <div v-if="hadPermission(3, 1)" class="d-flex mt-2">
          <export-place-data
            class="mr-2"
            title="Exportar logs"
            :onClick="controller.exportPlaceLogs"
          />

          <export-place-data
            title="Exportar Eventos"
            :onClick="controller.exportPlaceEvents"
          />
        </div>
      </div>

      <health-check
        :onClick="controller.healthCheck"
        :lastHealthCheck="controller.lastHealthCheck"
      />
    </div>

    <v-row  class="mt-4 pa-4" :class="$vuetify.theme.isDark ? 'background_screen' : 'white-bg'">
      <v-col v-for="(item, index) in controller.pumpMotoPagination.items" :key="index" cols="12" sm="6" md="4" lg="3">
        <pump-moto-card
          :pump-moto="item"
          :events="pumpMotoEvents"
          :onToggleSelected="toggleItemSelected"
          :onClick="toggleStatus"
          :engineName="computedEngineName(item.id)"
          :pumpName="computedPumpName(item.id)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
const defaultParams = {
  sort: 2,
  descending: false,
  page: 1,
  itemsPerPage: 40,
  search: '',
  status: 0
}
const AllParams = {
  sort: 2,
  descending: false,
  page: 1,
  itemsPerPage: 1000,
  search: '',
  status: 0
}
import { axosInstance } from "@/di/axios_instance_di";
import _ from "lodash";

import { remoteControlController } from "@/di/di";
import { snackbar } from '@/core/controller/snackbar_controller';

import ExportPlaceData from '../components/ExportPlaceData.vue';
import HealthCheck from '../components/HealthCheck.vue';
import LastPlaceEvent from "../components/LastPlaceEvent.vue";
import PumpMotoCard from '../components/PumpMotoCard.vue';

export default {
  components: {
    ExportPlaceData,
    HealthCheck,
    LastPlaceEvent,
    PumpMotoCard
  },
  data: (context) => ({
    controller: remoteControlController(context),
    activationModal: false,
    pumpMoto: [],
    engines: [],
    pumps: [],
    delayedStatus: '',
    selectAll: false,
    pumpMotoEvents: {},

    pendingRefetchTimeouts: [],
    shouldRefetchEvents: true,
    initialStatuses: [],
    attemps: 1
  }),
  methods: {
    async fetchPumpMoto(params) {
      await this.fetchPumps(AllParams);
      await this.fetchEngines(AllParams);
    },
    
    async fetchEngines(params) {
      try {
        const { data } = await axosInstance.get('/engine', {
          params
        })
        
        this.engines = data.items
        
      } catch (error) {
        console.error(error)
      }
    },
    async fetchPumps(params) {
      try {
        const { data } = await axosInstance.get('/pump', {
          params
        })
        this.pumps = data.items
      } catch (error) {
        console.error(error)
      }
    },
    async fetchLastEventForPumpMoto(pumpMoto) {
      try {
        const result = await this.controller.lastEventFor(pumpMoto);
        this.$set(this.pumpMotoEvents, pumpMoto.id, result);
      } catch (error) {
        console.error('Error fetching event:', error);
        this.$set(this.pumpMotoEvents, pumpMoto.id, { description: "Erro ao carregar evento" });
      }
    },
    // TODO: refac this code to make more readable/easy
    // deal with event updates
    async refetchPumpMotoWithRetry(ids) {
      if (this.attemps > 2) {
        this.controller.pumpMotoPagination.items.forEach(i => {
          i.isButtonDisabled = false
          i.loading = false
        });
        
        this.pendingRefetchTimeouts.forEach(clearTimeout)
        this.pendingRefetchTimeouts = []
        this.attemps = 1
        return
      }

      if (this.attemps > 1) {
        snackbar.show({ 
          message: "A atualizacao esta demorando um pouco mais que o esperado, tentando novamente", 
          color: 'blue', 
          timeout: 5000 
        });
      }

      const timeoutId = setTimeout(async () => {
        await this.controller.paginate();

        this.controller.pumpMotoPagination.items.forEach(i => {
          if (!ids.includes(i.id)) return

          this.$set(i, 'loading', true);
          this.$set(i, 'isButtonDisabled', true);
        });

        const currentStatues = this.controller.pumpMotoPagination.items.map(item => item.Status)
        const shouldRefetch = _.isEqual(currentStatues, this.initialStatuses)

        if (shouldRefetch) this.refetchPumpMotoWithRetry(ids);
        else {

          this.controller.pumpMotoPagination.items.forEach(i => {
            this.$set(i, 'loading', false);
            this.$set(i, 'isButtonDisabled', false);
          });
        }
      }, 10000 / this.attemps);

      this.pendingRefetchTimeouts.push(timeoutId)
      this.attemps += 1
    },
    toggleSelectAll() {
      this.controller.pumpMotoPagination.items.forEach(item => {
        item.checkbox = this.selectAll;
      });
    },
    // TODO: avoid fetch events on toggle the status
    async toggleStatus(item) {
      this.initialStatuses = this.controller.pumpMotoPagination.items.map(item => item.Status)

      this.$set(item, 'loading', true);

      const success = await this.controller.handleChange(item);

      if (!success) {
        this.$set(item, 'withPump', false);
        this.$set(item, 'loading', false);

        return;
      };

      await this.refetchPumpMotoWithRetry([item.id]);
    },
    computedPumpName(id) {
      const pump = this.pumps.find(pump => pump.id === id);
      return pump ? `Bomba ${pump.name} (${id})` : '';
    },

    computedEngineName(id) {
      const engine = this.engines.find(engine => engine.id === id);
      return engine ? `Motor ${engine.name} (${id})` : '';
    },

    toggleSelectAll() {
      this.controller.pumpMotoPagination.items.forEach(item => {
        item.checkbox = this.selectAll;
      });
    },
    toggleItemSelected(item) {
      this.shouldRefetchEvents = false

      this.controller.pumpMotoPagination.items.forEach((i) => {
        this.$set(i, 'isButtonDisabled', true);
      });

      if(this.selectedItems.length === 0) {
        this.controller.pumpMotoPagination.items.forEach((i) => {
          this.$set(i, 'isButtonDisabled', false);
        });

        this.shouldRefetchEvents = true
      }
    },
    async toggleStatusForSelectedItems() {
      this.selectedItems.forEach(item => this.$set(item, 'loading', true))
      const items = this.selectedItems

      const success = await this.controller.handleMultiChange();

      if (!success) {
        this.selectedItems.forEach(item => {

          this.$set(item, 'withPump', false);
          this.$set(item, 'loading', false);
          return;
        });
      }

      this.shouldRefetchEvents = true

      await this.refetchPumpMotoWithRetry(items.map(i => i.id))
      await Promise.all(items.map(item => this.fetchLastEventForPumpMoto(item)));
    },
  },
  
  watch: {
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search": _.debounce(function () {
      this.controller.watchSearch();
    }, 500),
    "controller.optionsPlace"() {
      this.controller.watchOptionsPlace();
    },
    "controller.searchPlace": _.debounce(function () {
      this.controller.watchSearchPlace();
    }, 500),
    "controller.searchTracking": _.debounce(function () {
      this.controller.watchSearchTracking();
    }, 500),
    "controller.optionsTracking"() {
      this.controller.watchOptionsTracking();
    },
    "controller.searchCompany": _.debounce(function () {
      this.controller.watchSearchCompany();
    }, 500),
    "controller.optionsCompany"() {
      this.controller.watchOptionsCompany();
    },
    'selectedEngine.id': function (newVal) {
      this.controller.pumpMoto.EngineID = newVal;
    },
    'controller.selectedPlace':  function (v) {
      this.controller.fetchLastHealthCheck()
      this.controller.fetchLastPlaceEvent()
    },
    'controller.pumpMotoPagination.items': async function(newItems) {
      if (newItems && newItems.length > 0 && this.shouldRefetchEvents) {
        await Promise.all(newItems.map(item => this.fetchLastEventForPumpMoto(item)));
      }
    },
  },
  computed: {
    selectedItems() {
      return this.controller.pumpMotoPagination.items.filter(item => item.checkbox);
    },
  },
  async mounted() {
    await this.fetchPumpMoto(defaultParams);
    this.controller.paginate();   
  },
}
</script>

<style>
.warning-message {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.white-bg {
  background-color: white !important;
}
</style>
